import { useState } from 'react';

import { TeacherGradeUpdateMarkMutationVariables } from '@school_ify/schoolify-repository/src/teacher/types';

import AssignmentsService from 'domain/services/teacher/dashboard/assignments/Index';

export default function useGrading() {
  const [students, setStudents] = useState<any[]>();
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [assignmentId, setAssignmentId] = useState<string>();

  async function getStudentsForGrading(id: string) {
    setAssignmentId(id);
    setLoading(true);
    try {
      const students = await AssignmentsService.getTeacherCassStudentsQuery(id);
      setStudents(students);
    } catch (err) {
      setError(err);
    }
    setLoading(false);
  }

  async function addStudentGrade(id, mark) {
    const data: TeacherGradeUpdateMarkMutationVariables = {
      id,
      mark_id: mark,
    };
    setLoading(true);
    try {
      await AssignmentsService.updateStudentMark(data);
      await getStudentsForGrading(assignmentId);
    } catch (err) {
      setError(err);
    }
    setLoading(false);
  }

  return {
    isLoading,
    error,
    students,
    getStudentsForGrading,
    setStudents,
    addStudentGrade,
  };
}
